module.exports = __webpack_public_path__ + "media/images/flags/32/Bulgaria-b8e4475a5f2ddeb3e16bd52800652222.png";